import { render, staticRenderFns } from "./GridResume.vue?vue&type=template&id=2ffb44c4&"
import script from "./GridResume.vue?vue&type=script&lang=js&"
export * from "./GridResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports